import React from "react";

import { Host } from "@/types";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";

type HostExcerpt = Pick<Host, "id" | "name" | "ipAddress">;

export function SelectHost({
  id,
  hosts,
  onSelect,
  host
}: {
  id: string;
  hosts: HostExcerpt[];
  host?: HostExcerpt;
  onSelect?: (host?: HostExcerpt) => void;
}) {
  const [selected, setSelected] = React.useState<HostExcerpt | null>(host || null);

  return (
    <>
      <Select
        value={selected?.id}
        onValueChange={id => {
          const host = hosts.find(host => host.id === id);
          setSelected(host || null);
          onSelect && onSelect(host);
        }}
      >
        <SelectTrigger className="text-left" id={id}>
          <SelectValue placeholder="Select host" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {hosts?.map(host => (
              <SelectItem key={host.id} value={host.id}>
                {host.name} ({host.ipAddress})
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </>
  );
}
